import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/*
 * Uppercase-faint key + mono value rows (Servers cards, Game Info sidebar).
 */
export interface KeyValueRow {
  key: string;
  value: ReactNode;
  /** Value color accent. */
  tone?: 'default' | 'green' | 'gold' | 'orange' | 'dim';
}

const TONE: Record<NonNullable<KeyValueRow['tone']>, string> = {
  default: 'text-text',
  green: 'text-green',
  gold: 'text-gold',
  orange: 'text-orange',
  dim: 'text-dim',
};

export function KeyValueRows({ rows, className }: { rows: KeyValueRow[]; className?: string }) {
  return (
    <dl className={cn('flex flex-col', className)}>
      {rows.map((row) => (
        <div key={row.key} className="flex items-baseline gap-3 py-1">
          <dt className="text-faint w-24 shrink-0 text-[11px] uppercase tracking-wide">
            {row.key}
          </dt>
          <dd className={cn('font-mono text-[13px]', TONE[row.tone ?? 'default'])}>{row.value}</dd>
        </div>
      ))}
    </dl>
  );
}
